/* ============================================================
   Kaynaturalz — urgency + social proof
   - Rotating purchase notifications (bottom-left)
   - One-time low-stock popup (bottom-right)
   These are front-end illustrations of social proof / urgency.
   For Shopify, feed PURCHASES from a live orders/sales-proof app
   and STOCK from {{ product.selling_plan }} / inventory_quantity.
   ============================================================ */
(function () {
  "use strict";

  var CDN = "https://cdn.shopify.com/s/files/1/0411/3262/1976/files/";
  var SOAP = CDN + "kn-tum-front.png?v=1784835388";
  var OAT = CDN + "kn-oat-front.png?v=1784835388";
  var OIL = CDN + "DSC01925.jpg?v=1756747606";
  var BUNDLE = CDN + "biggest-bundle-tumeric.jpg?v=1784824710";
  var MASK = CDN + "DSC01967.jpg?v=1755719119";
  var DUO = CDN + "bundle-tumeric.jpg?v=1784822838";

  // First-name + last initial only — no full names.
  var PURCHASES = [
    { name: "Stay A.", city: "Atlanta, GA", item: "Fade & Glow Bundle", img: BUNDLE, mins: 3 },
    { name: "Jaelyn M.", city: "Houston, TX", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 6 },
    { name: "Brielle T.", city: "Charlotte, NC", item: "Glow Oil", img: OIL, mins: 8 },
    { name: "Imani R.", city: "Chicago, IL", item: "Duo Skincare Bundle", img: DUO, mins: 11 },
    { name: "Naomi W.", city: "Newark, NJ", item: "Detoxifying Clay Mask", img: MASK, mins: 13 },
    { name: "Kayla D.", city: "Los Angeles, CA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 16 },
    { name: "Simone B.", city: "Detroit, MI", item: "Ultimate Glow Bundle", img: BUNDLE, mins: 18 },
    { name: "Aaliyah F.", city: "Dallas, TX", item: "Glow Essentials Bundle", img: SOAP, mins: 21 },
    { name: "Destiny H.", city: "Brooklyn, NY", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 24 },
    { name: "Maya J.", city: "Washington, DC", item: "Fade & Glow Bundle", img: BUNDLE, mins: 27 },
    { name: "Zaria C.", city: "Philadelphia, PA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 29 },
    { name: "Nia P.", city: "Baltimore, MD", item: "Glow Oil", img: OIL, mins: 32 },
    { name: "Jada L.", city: "Memphis, TN", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 34 },
    { name: "Amara S.", city: "Bronx, NY", item: "Duo Skincare Bundle", img: DUO, mins: 37 },
    { name: "Taylor G.", city: "New Orleans, LA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 39 },
    { name: "Jasmine O.", city: "Miami, FL", item: "Glow Essentials Bundle", img: SOAP, mins: 42 },
    { name: "Kennedi B.", city: "Columbus, OH", item: "Detoxifying Clay Mask", img: MASK, mins: 45 },
    { name: "Ariana T.", city: "Jacksonville, FL", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 47 },
    { name: "Sanaa M.", city: "Birmingham, AL", item: "Fade & Glow Bundle", img: BUNDLE, mins: 50 },
    { name: "Camille R.", city: "Cleveland, OH", item: "Glow Oil", img: OIL, mins: 53 },
    { name: "Kiara W.", city: "Indianapolis, IN", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 56 },
    { name: "Layla D.", city: "St. Louis, MO", item: "Organic Oat Soap Bar", img: OAT, mins: 58 },
    { name: "Mariah J.", city: "Oakland, CA", item: "Ultimate Glow Bundle", img: BUNDLE, mins: 62 },
    { name: "Brianna H.", city: "Sacramento, CA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 65 },
    { name: "Asia F.", city: "Las Vegas, NV", item: "Duo Skincare Bundle", img: DUO, mins: 68 },
    { name: "Trinity L.", city: "San Antonio, TX", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 71 },
    { name: "Gabrielle N.", city: "Nashville, TN", item: "Glow Essentials Bundle", img: SOAP, mins: 74 },
    { name: "Aniya P.", city: "Richmond, VA", item: "Detoxifying Clay Mask", img: MASK, mins: 77 },
    { name: "Janae C.", city: "Norfolk, VA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 80 },
    { name: "Skylar B.", city: "Raleigh, NC", item: "Fade & Glow Bundle", img: BUNDLE, mins: 84 },
    { name: "Raven M.", city: "Durham, NC", item: "Glow Oil", img: OIL, mins: 88 },
    { name: "Diamond W.", city: "Columbia, SC", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 92 },
    { name: "Tiana R.", city: "Savannah, GA", item: "Organic Oat Soap Bar", img: OAT, mins: 96 },
    { name: "Hailey J.", city: "Montgomery, AL", item: "Duo Skincare Bundle", img: DUO, mins: 101 },
    { name: "Kamiyah D.", city: "Baton Rouge, LA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 106 },
    { name: "Alana T.", city: "Tampa, FL", item: "Glow Essentials Bundle", img: SOAP, mins: 111 },
    { name: "Cierra H.", city: "Jackson, MS", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 117 },
    { name: "Morgan P.", city: "Kansas City, MO", item: "Fade & Glow Bundle", img: BUNDLE, mins: 123 },
    { name: "Essence B.", city: "Milwaukee, WI", item: "Detoxifying Clay Mask", img: MASK, mins: 129 },
    { name: "Leila C.", city: "Minneapolis, MN", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 136 },
    { name: "Nyla W.", city: "Cincinnati, OH", item: "Glow Oil", img: OIL, mins: 143 },
    { name: "Aubrey M.", city: "Louisville, KY", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 151 },
    { name: "Selah R.", city: "Greensboro, NC", item: "Ultimate Glow Bundle", img: BUNDLE, mins: 159 },
    { name: "Jordyn D.", city: "Hartford, CT", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 168 },
    { name: "Sariah J.", city: "Tulsa, OK", item: "Duo Skincare Bundle", img: DUO, mins: 177 },
    { name: "Aniyah F.", city: "Oklahoma City, OK", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 187 },
    { name: "Bria T.", city: "Phoenix, AZ", item: "Glow Essentials Bundle", img: SOAP, mins: 198 },
    { name: "Khloe P.", city: "Boston, MA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 210 },
    { name: "Janiya H.", city: "Augusta, GA", item: "Fade & Glow Bundle", img: BUNDLE, mins: 223 },
    { name: "Reagan B.", city: "Shreveport, LA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 238 },
    { name: "Amber J.", city: "Capitol Heights, MD", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 247 },
    { name: "Kiana T.", city: "Lithonia, GA", item: "Fade & Glow Bundle", img: BUNDLE, mins: 256 },
    { name: "Precious M.", city: "Jacksonville, FL", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 264 },
    { name: "Deja R.", city: "Temple Hills, MD", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 273 },
    { name: "Shanice B.", city: "Atlanta, GA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 281 },
    { name: "Chanel W.", city: "Chicago, IL", item: "Glow Oil", img: OIL, mins: 290 },
    { name: "Imari D.", city: "Suitland, MD", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 299 },
    { name: "Tamia H.", city: "Stone Mountain, GA", item: "Duo Skincare Bundle", img: DUO, mins: 308 },
    { name: "Zoe P.", city: "Baltimore, MD", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 318 },
    { name: "Kennedy L.", city: "Orlando, FL", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 327 },
    { name: "Alyssa C.", city: "Philadelphia, PA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 337 },
    { name: "Nyah B.", city: "Decatur, GA", item: "Fade & Glow Bundle", img: BUNDLE, mins: 348 },
    { name: "Jaida M.", city: "Upper Marlboro, MD", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 359 },
    { name: "Sasha R.", city: "Charlotte, NC", item: "Detoxifying Clay Mask", img: MASK, mins: 371 },
    { name: "Egypt T.", city: "Waldorf, MD", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 383 },
    { name: "Milan D.", city: "Memphis, TN", item: "Glow Oil", img: OIL, mins: 396 },
    { name: "Amina W.", city: "Lawrenceville, GA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 409 },
    { name: "Serenity H.", city: "West Palm Beach, FL", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 423 },
    { name: "Lauren B.", city: "Hyattsville, MD", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 438 },
    { name: "Bianca J.", city: "Bronx, NY", item: "Fade & Glow Bundle", img: BUNDLE, mins: 454 },
    { name: "Tiara S.", city: "Birmingham, AL", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 470 },
    { name: "Camryn P.", city: "Houston, TX", item: "Glow Oil", img: OIL, mins: 487 },
    { name: "Nevaeh D.", city: "Bowie, MD", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 505 },
    { name: "Kayla R.", city: "Hampton, GA", item: "Duo Skincare Bundle", img: DUO, mins: 524 },
    { name: "Jasmine T.", city: "Port St. Lucie, FL", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 544 },
    { name: "Aliyah W.", city: "Norfolk, VA", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 565 },
    { name: "Destiny B.", city: "Newark, NJ", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 587 },
    { name: "Sydney M.", city: "Baton Rouge, LA", item: "Fade & Glow Bundle", img: BUNDLE, mins: 610 },
    { name: "Alexis H.", city: "Washington, DC", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 634 },
    { name: "Morgan D.", city: "Savannah, GA", item: "Glow Oil", img: OIL, mins: 659 },
    { name: "Kamryn J.", city: "Detroit, MI", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 685 },
    { name: "Riley B.", city: "Richmond, VA", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 712 },
    { name: "Nia W.", city: "Rock Hill, SC", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 740 },
    { name: "Skye T.", city: "Dallas, TX", item: "Detoxifying Clay Mask", img: MASK, mins: 769 },
    { name: "Journee M.", city: "Cincinnati, OH", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 799 },
    { name: "Amari D.", city: "Stockbridge, GA", item: "Fade & Glow Bundle", img: BUNDLE, mins: 830 },
    { name: "Kali R.", city: "Brooklyn, NY", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 862 },
    { name: "Zaria H.", city: "Tallahassee, FL", item: "Glow Oil", img: OIL, mins: 895 },
    { name: "Londyn B.", city: "District Heights, MD", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 929 },
    { name: "Reign J.", city: "McDonough, GA", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 964 },
    { name: "Aubree W.", city: "Alexandria, VA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1000 },
    { name: "Saniyah T.", city: "Montgomery, AL", item: "Duo Skincare Bundle", img: DUO, mins: 1037 },
    { name: "Paris M.", city: "Indianapolis, IN", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1075 },
    { name: "Genesis D.", city: "Fort Lauderdale, FL", item: "Fade & Glow Bundle", img: BUNDLE, mins: 1114 },
    { name: "Harmony B.", city: "Lanham, MD", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1154 },
    { name: "Kyla R.", city: "Conyers, GA", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 1195 },
    { name: "Trinity W.", city: "Virginia Beach, VA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1237 },
    { name: "Mya H.", city: "San Antonio, TX", item: "Glow Oil", img: OIL, mins: 1280 },
    { name: "Aniyah B.", city: "Cleveland, OH", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1324 },
    { name: "Kaylee M.", city: "Sumter, SC", item: "Fade & Glow Bundle", img: BUNDLE, mins: 1369 },
    { name: "Selah D.", city: "Staten Island, NY", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1415 },
    { name: "Nylah J.", city: "Miami Lakes, FL", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 1462 },
    { name: "Ava R.", city: "Gaithersburg, MD", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1510 },
    { name: "Zuri B.", city: "Griffin, GA", item: "Detoxifying Clay Mask", img: MASK, mins: 1559 },
    { name: "Leilani W.", city: "Mobile, AL", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1609 },
    { name: "Maya T.", city: "New Orleans, LA", item: "Glow Oil", img: OIL, mins: 1660 },
    { name: "Chloe M.", city: "Aurora, IL", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1712 },
    { name: "Kamari D.", city: "Union City, GA", item: "Fade & Glow Bundle", img: BUNDLE, mins: 1765 },
    { name: "Sanaa H.", city: "Woodbridge, VA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1819 },
    { name: "Brooklynn B.", city: "Jackson, MS", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 1874 },
    { name: "Talia R.", city: "Waterbury, CT", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 1930 },
    { name: "Nova J.", city: "Pensacola, FL", item: "Duo Skincare Bundle", img: DUO, mins: 1987 },
    { name: "Ariel W.", city: "Kennesaw, GA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 2045 },
    { name: "Simone T.", city: "Camp Springs, MD", item: "Glow Oil", img: OIL, mins: 2104 },
    { name: "Journee B.", city: "Rochester, NY", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 2164 },
    { name: "Dior M.", city: "Covington, GA", item: "Fade & Glow Bundle", img: BUNDLE, mins: 2225 },
    { name: "Amirah D.", city: "Ocala, FL", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 2287 },
    { name: "Kaia R.", city: "Milwaukee, WI", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 2350 },
    { name: "Layla W.", city: "Greenville, SC", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 2414 },
    { name: "Sariyah H.", city: "Danville, VA", item: "Detoxifying Clay Mask", img: MASK, mins: 2479 },
    { name: "Erykah B.", city: "Columbus, GA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 2545 },
    { name: "Nadia M.", city: "Grand Prairie, TX", item: "Glow Oil", img: OIL, mins: 2612 },
    { name: "Iyana D.", city: "Merrillville, IN", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 2680 },
    { name: "Cadence J.", city: "Mableton, GA", item: "Fade & Glow Bundle", img: BUNDLE, mins: 2749 },
    { name: "Amaya W.", city: "London, England", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 2819 },
    { name: "Journey B.", city: "Valdosta, GA", item: "Organic Oat & Honey Soap Bar", img: OAT, mins: 2890 },
    { name: "Sade R.", city: "East Orange, NJ", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 2962 },
    { name: "Kimora H.", city: "Dayton, OH", item: "Duo Skincare Bundle", img: DUO, mins: 3035 },
    { name: "Nyla T.", city: "Brampton, Ontario", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 3109 },
    { name: "Zariah M.", city: "Antioch, TN", item: "Glow Oil", img: OIL, mins: 3184 },
    { name: "Halle D.", city: "Snellville, GA", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 3260 },
    { name: "Kaydence B.", city: "Fayetteville, NC", item: "Fade & Glow Bundle", img: BUNDLE, mins: 3337 },
    { name: "Amber W.", city: "Birmingham, England", item: "Organic Turmeric Soap Bar", img: SOAP, mins: 3415 }
  ];

  function el(html) {
    var t = document.createElement("template");
    t.innerHTML = html.trim();
    return t.content.firstChild;
  }

  /* ---------- Purchase-proof toast (bottom-left) ---------- */
  function buildProof() {
    var toast = el(
      '<div class="proof" role="status" aria-live="polite" hidden>' +
        '<img class="proof__img" alt="" />' +
        '<div class="proof__body">' +
          '<p class="proof__line"><strong class="proof__name"></strong> in <span class="proof__city"></span></p>' +
          '<p class="proof__item">just bought the <strong class="proof__product"></strong></p>' +
          '<p class="proof__time"><span class="proof__dot"></span><span class="proof__ago"></span> · Verified purchase</p>' +
        '</div>' +
        '<button class="proof__close" aria-label="Dismiss">&times;</button>' +
      '</div>'
    );
    document.body.appendChild(toast);

    var img = toast.querySelector(".proof__img");
    var nameEl = toast.querySelector(".proof__name");
    var cityEl = toast.querySelector(".proof__city");
    var productEl = toast.querySelector(".proof__product");
    var agoEl = toast.querySelector(".proof__ago");
    var i = Math.floor(Math.random() * PURCHASES.length), hideTimer, dismissed = false;

    function fmtAgo(m) {
      if (m < 60) return m + " min ago";
      var h = Math.floor(m / 60), r = m % 60;
      if (h < 24) return h + (h === 1 ? " hr" : " hrs") + (r ? " " + r + " min" : "") + " ago";
      return "today";
    }
    function render(p) {
      img.src = p.img;
      nameEl.textContent = p.name.split(" ")[0];
      cityEl.textContent = p.city;
      productEl.textContent = p.item;
      agoEl.textContent = fmtAgo(p.mins);
    }
    function hideNow() {
      toast.classList.remove("is-on");
      setTimeout(function () { if (!dismissed) toast.hidden = true; }, 460);
    }
    toast.querySelector(".proof__close").addEventListener("click", function () {
      dismissed = true; clearTimeout(hideTimer); hideNow();
    });
    return {
      show: function (dur) {
        if (dismissed) return;
        render(PURCHASES[i]);
        i = (i + 1) % PURCHASES.length;
        toast.hidden = false;
        requestAnimationFrame(function () { toast.classList.add("is-on"); });
        hideTimer = setTimeout(hideNow, dur);
      },
      isDismissed: function () { return dismissed; }
    };
  }

  /* ---------- Low-stock popup (bottom-right, once per session) ---------- */
  function buildLowStock() {
    if (sessionStorage.getItem("kn_lowstock_seen") === "1") return null;
    var left = 6 + Math.floor(Math.random() * 5); // 6-10 left
    var pop = el(
      '<div class="lowstock" role="alert" hidden>' +
        '<button class="lowstock__close" aria-label="Dismiss">&times;</button>' +
        '<img class="lowstock__img" src="' + SOAP + '" alt="Organic Turmeric Soap Bar" />' +
        '<div class="lowstock__body">' +
          '<span class="lowstock__flag">⚡ Selling fast</span>' +
          '<p class="lowstock__title">Only <strong>' + left + ' left</strong> in this restock</p>' +
          '<p class="lowstock__sub">The Organic Turmeric Soap sells out every drop. Don’t miss this batch.</p>' +
          '<div class="lowstock__bar"><i style="width:' + (left * 7 + 8) + '%"></i></div>' +
          '<a href="#feature" class="lowstock__cta">Grab yours →</a>' +
        '</div>' +
      '</div>'
    );
    document.body.appendChild(pop);
    var hideTimer, used = false;
    function hideNow() {
      pop.classList.remove("is-on");
      setTimeout(function () { pop.hidden = true; }, 460);
    }
    function close() {
      clearTimeout(hideTimer);
      sessionStorage.setItem("kn_lowstock_seen", "1");
      hideNow();
    }
    pop.querySelector(".lowstock__close").addEventListener("click", close);
    pop.querySelector(".lowstock__cta").addEventListener("click", close);
    return {
      show: function (dur) {
        if (used) return;
        used = true;
        sessionStorage.setItem("kn_lowstock_seen", "1");
        pop.hidden = false;
        requestAnimationFrame(function () { pop.classList.add("is-on"); });
        hideTimer = setTimeout(hideNow, dur);
      },
      isUsed: function () { return used; }
    };
  }

  /* ---------- Scheduler ----------
     No popups for the first 45s. After that, exactly one popup at a time,
     spaced 23-28s apart. Never two at once. Also defers if a third-party
     popup (email / Loox review) is currently on screen. */
  var QUIET_MS  = 45000;
  var GAP_MIN   = 23000;
  var GAP_MAX   = 28000;
  var VISIBLE_MS = 5600;
  function rnd(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }

  function appPopupOpen() {
    try {
      var sels = ['.loox-reviews-popup', '[class*="loox"][class*="opup"]',
                  '[id*="omnisend"]', '[class*="omnisend"]',
                  '.klaviyo-form-overlay', '[class*="privy"][class*="popup"]'];
      for (var s = 0; s < sels.length; s++) {
        var nodes = document.querySelectorAll(sels[s]);
        for (var n = 0; n < nodes.length; n++) {
          var eln = nodes[n], r = eln.getBoundingClientRect(), cs = getComputedStyle(eln);
          if (r.width > 60 && r.height > 60 && cs.display !== "none" && cs.visibility !== "hidden" && cs.opacity !== "0") return true;
        }
      }
    } catch (e) {}
    return false;
  }

  document.addEventListener("DOMContentLoaded", function () {
    var proof = buildProof();
    var lowstock = buildLowStock(); // null if already seen this session
    var defers = 0;

    function tick() {
      if (proof.isDismissed()) return;
      // Don't stack on top of an app popup, but never wait forever.
      if (defers < 5 && appPopupOpen()) { defers++; setTimeout(tick, 3500); return; }
      defers = 0;

      if (lowstock && !lowstock.isUsed()) {
        lowstock.show(VISIBLE_MS);
      } else {
        proof.show(VISIBLE_MS);
      }
      setTimeout(tick, rnd(GAP_MIN, GAP_MAX));
    }

    setTimeout(tick, QUIET_MS);
  });
})();
